<template>
    <div class="container">
        <p><strong>Nom : </strong>{{ post.lastName }}</p>
        <p><strong>Prenom : </strong>{{ post.firstName }}</p>
        <p><strong>Email : </strong>{{ post.email }}</p>
        <p><strong>Phone : </strong>{{ post.phone }}</p>
        <p><strong>Pourquoi voulez-vous nous rejoindre ? : </strong> {{ post.whyJoinUs }}</p>
        <p><u><strong><a :href=post.linkedIn target="_blank">LinkedIn</a></strong></u> </p>
        <p><u><strong><a :href=post.facebook target="_blank">Facebook</a></strong> </u></p>
        <p><u><strong><a :href=post.instagram target="_blank">Instagram</a></strong></u> </p>
        <p><u><strong><a :href="`${imgUrl}/${post.cvFile}`" target="_blank">CV</a></strong></u> </p>
        <button type="button" class="btn btn-light me-2" v-on:click="deletePost" >Delete</button>
        <button type="button" class="btn btn-light" v-on:click="$emit('cancel' , {})">Cancel</button>
    </div>
</template>
<script>
import axios from 'axios'
import APIs from '../../../../config'
export default {
    name : 'DetailsPost' , 
    data(){
        return {
            imgUrl : APIs.API_IMAGES
        }
    },
    props : {
        post : Object 
    },
    created(){
    },
    
    methods : {
        deletePost(){
            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')  
            this.$swal.fire({
            title: 'Do you really want to delete',
            text: "",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes , delete it '
            }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${APIs.API_URL}/cv/${user_id}/${this.post._id}` ,{
                headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${get_token}`
                }
                })
                .then(() => {
                    this.$swal.fire(
                    'deleted',
                    '',
                    'success'
                    )
                    this.$emit("refresh")
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.container {
    margin-top: 120px;
    padding-top: 40px;
}
p {
    font-size: 20px;
}
.orders {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    background-color: #FFFFFF;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 20px;
    max-width: 400px;
    img {
        width: 70px;
        height: 70px;
    }
    div p {
        font-size: 13px;
        margin: 0;
    }
}
</style>